import {useParams} from "react-router-dom";
import {ViewDocumentPanel} from "document/component/container";
import {SistemaService} from "abastecemento/service";

const ViewSistemaDocumentPanel = () => {
    const {idSistema} = useParams();

    const handleSetFeaturedImage = documentId => {
        return SistemaService.updateWithPatch({
            id: idSistema,
            featured_image: documentId,
        });
    };

    const handleSetFeaturedDocument = documentId => {
        return SistemaService.updateWithPatch({
            id: idSistema,
            featured_document: documentId,
        });
    };

    return (
        <ViewDocumentPanel
            onSetFeaturedImage={handleSetFeaturedImage}
            onSetFeaturedDocument={handleSetFeaturedDocument}
        />
    );
};

export default ViewSistemaDocumentPanel;
